import React from 'react'

const EmptyBoxIcon = ({
   width = '100%',
   height = '100%',
   className = '',
   strokeWidth = '2',
   color = "var(--color-vb-blue)"
}) => {
   return (
      <svg
         width={width}
         height={height}
         viewBox="0 0 261 260"
         preserveAspectRatio="xMidYMid meet"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         className={className}
      >
         <path
            d="M240.562 91.3598L88.1417 9.78105C84.7019 7.95489 80.8669 7 76.9724 7C73.078 7 69.2429 7.95489 65.8032 9.78105L20.7559 33.2303C16.6942 35.4561 13.2961 38.7202 10.9088 42.6892C8.52153 46.6581 7.23056 51.1897 7.16781 55.8208C7.10505 60.452 8.27277 65.0169 10.5517 69.049C12.8305 73.0812 16.1389 76.4362 20.1388 78.7713L170.955 164.299C174.618 166.331 178.737 167.397 182.926 167.397C187.115 167.397 191.234 166.331 194.897 164.299L241.673 136.654C245.59 134.26 248.809 130.878 251.005 126.846C253.202 122.815 254.299 118.276 254.186 113.686C254.074 109.097 252.756 104.617 250.364 100.698C247.973 96.7795 244.592 93.5588 240.562 91.3598Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M20.6325 91.3598L173.053 9.78105C176.492 7.95489 180.327 7 184.222 7C188.116 7 191.951 7.95489 195.391 9.78105L240.438 33.2303C244.533 35.3999 247.978 38.618 250.421 42.5555C252.864 46.493 254.217 51.0086 254.342 55.6407C254.468 60.2728 253.361 64.8551 251.135 68.9191C248.909 72.9831 245.644 76.3831 241.673 78.7713L90.2398 164.299C86.5767 166.331 82.457 167.397 78.2683 167.397C74.0797 167.397 69.9599 166.331 66.2968 164.299L19.5218 136.654C15.6042 134.26 12.3855 130.878 10.189 126.846C7.99241 122.815 6.89531 118.276 7.00787 113.686C7.12042 109.097 8.43866 104.617 10.8302 100.698C13.2217 96.7795 16.6023 93.5588 20.6325 91.3598Z"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M130.597 253.777V142.701"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M229.331 148.872V190.464C229.336 195.122 228.061 199.692 225.645 203.675C223.229 207.658 219.765 210.901 215.632 213.049L141.581 251.062C138.188 252.825 134.421 253.745 130.597 253.745C126.774 253.745 123.006 252.825 119.613 251.062L45.5628 213.049C41.4294 210.901 37.9656 207.658 35.5498 203.675C33.1339 199.692 31.8587 195.122 31.8635 190.464V148.872"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M117 73L145 101M117 101L145 73"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   )
}

export default EmptyBoxIcon
